import { setClusterMetricFilter as setClusterMetricFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    metricFilter?: Number,
}

export const applyClusterMetricFilter = ({
    metricFilter,
    eventEmitter,
}: Props) => {
    setClusterMetricFilterDiagram(metricFilter);
    apiProvider.updateDiagramCluster({source: 'applyClusterMetricFilter'});
    eventEmitter.emit(Event.applyClusterMetricFilter);
};
